import React from "react";
import { Input } from "reactstrap";

const DefaultColumnFilter = ({ column: { filterValue, setFilter } }) => {
  return <Input bsSize={"sm"} value={filterValue || ""} onChange={(e) => setFilter(e.target.value || undefined)} />;
};

export default DefaultColumnFilter;
